import dayjs from 'dayjs'

export const formatTooltipDate = (entryDate: string) => {
    const [date, time] = entryDate.split('T')
    const hhmm = time.slice(0, 5)
    const formattedDate = dayjs(date).format('MMMM D, YYYY')
    return `${formattedDate}, ${hhmm}`
}
